<template>
	<section>
		<Button type="primary" @click="insteadOfOrder">代下单</Button>
		<Button type="primary" @click="frontOrder">前台下单</Button>
		<Button type="warning" @click="suppleOrder">补录订单</Button>
		<section class="order-list">
			<Form :model="orderListForm" inline>
				<Row>
					<FormItem label="创建日期：" prop="createDate" :label-width="84">
						<DatePicker v-model="orderListForm.createDate" @on-change="dateRange => {changeDate(dateRange, 'orderListForm', 'createDate')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px" :clearable="false"></DatePicker>
					</FormItem>
					<FormItem label="预入住日期：" prop="checkInDate" :label-width="100">
						<DatePicker v-model="orderListForm.checkInDate" @on-change="dateRange => {changeDate(dateRange, 'orderListForm', 'checkInDate')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</FormItem>
					<FormItem label="预退房日期：" prop="quitDate" :label-width="100">
						<DatePicker v-model="orderListForm.quitDate" @on-change="dateRange => {changeDate(dateRange, 'orderListForm', 'quitDate')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</FormItem>
				</Row>
				<Row>
					<FormItem prop="orderNo" label="订单号：" :label-width="80">
						<Input type="text" v-model="orderListForm.orderNo" placeholder="请输入查询关键字"></Input>
					</FormItem>
					<FormItem prop="phone" label="手机号：" :label-width="80">
						<Input type="text" v-model="orderListForm.phone" placeholder="请输入查询关键字"></Input>
					</FormItem>
					<FormItem prop="roomNo" label="房间号：" :label-width="80">
						<Input type="text" v-model="orderListForm.roomNo" placeholder="请输入查询关键字"></Input>
					</FormItem>
					<FormItem prop="otherNo" label="OTA号：" :label-width="80">
						<Input type="text" v-model="orderListForm.otherNo" placeholder="请输入查询关键字"></Input>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="订单来源：" prop="sourceType" :label-width="84">
						<Select v-model="orderListForm.sourceType" filterable>
							<Option value="S00">全部</Option>
							<Option v-for="(type, index) in sourceType" :key="index" :value="type.id">{{type.name}}</Option>
						</Select>
					</FormItem>
					<FormItem label="订单状态：" prop="stat" :label-width="84">
						<Select v-model="orderListForm.stat" filterable>
							<Option value="S00">全部</Option>
							<Option :value="1">有效</Option>
							<Option :value="2">无效</Option>
						</Select>
					</FormItem>
					<FormItem label="支付状态：" prop="payStat" :label-width="84">
						<Select v-model="orderListForm.payStat" filterable>
							<Option value="S00">全部</Option>
							<Option :value="1">未支付</Option>
							<Option :value="2">已支付</Option>
						</Select>
					</FormItem>
					<FormItem label="租房类型：" prop="rentType" :label-width="84">
						<Select v-model="orderListForm.rentType" filterable>
							<Option value="S00">全部</Option>
							<Option :value="1">短租</Option>
							<Option :value="2">长租</Option>
							<Option :value="3">钟点房</Option>
						</Select>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="城市：" prop="city" :label-width="80">
						<Select ref="resetSelect" v-model="orderListForm.city" @on-change="clearValue('city')" @on-open-change="cityOpenChange" clearable filterable>
							<Option v-for="(city, index) in allCities" :key="index" :value="city">{{city}}</Option>
						</Select>
					</FormItem>
					<!-- <FormItem label="热点：" prop="hotspotName" :label-width="80">
            <Select v-model="orderListForm.hotspotName" ref="hotspotName" @on-change="clearValue('hotspotName')" clearable filterable>
              <Option v-for="hotSpot in hotSpots" :key="hotSpot.sourceId" :value="hotSpot.sourceId">{{hotSpot.sourceName}}</Option>
            </Select>
          </FormItem> -->
					<FormItem label="门店：" prop="chainName" :label-width="80">
						<Select v-model="orderListForm.chainName" ref="chainName" clearable filterable>
							<Option v-for="hotel in hotels" :key="hotel.sourceId" :value="hotel.sourceId">{{hotel.sourceName}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="orderName" label="姓名：" :label-width="80">
						<Input type="text" v-model="orderListForm.orderName" placeholder="请输入查询关键字"></Input>
					</FormItem>
					<FormItem prop="orderName" label="入住状态：" :label-width="84">
						<Select v-model="orderListForm.checkin" filterable>
							<Option value="S00">全部</Option>
							<Option :value="1">未入住</Option>
							<Option :value="2">已入住</Option>
							<Option :value="3">已退房</Option>
						</Select>
					</FormItem>
				</Row>
				<Row>
					<FormItem>
						<Button type="primary" @click="queryOrderListWithKeyword">查询</Button>
					</FormItem>
					<FormItem style="margin-left: 80px;">
						<Button type="primary" @click="exportOrderInfoExcel" :loading="exportBtn.exportOrderInfoExcel">导出筛选全部订单</Button>
					</FormItem>
					<FormItem>
						<Button type="primary" @click="exportCheckinInfoToExcel" :loading="exportBtn.exportCheckinInfoToExcel">导出子入住单</Button>
					</FormItem>
					<FormItem>
						<Button type="primary" @click="exportSelCheckinerInfo" :loading="exportBtn.exportSelCheckinerInfo">导出入住人信息</Button>
					</FormItem>
					<FormItem style="overflow: hidden;margin-left: 20px;">
						<Page show-sizer placement="top" :total="orderList.count" :current="orderList.page" :page-size="orderList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage" show-elevator></Page>
					</FormItem>
				</Row>
			</Form>
			<Table stripe :loading="orderList.loading" height="450" :columns="column" :data="orderList.data"></Table>
		</section>

		<Modal v-model="remarkForm.editRemarkModalDisplay" ref="editRemarkModal" :loading="true" title="添加备注" ok-text="提交" @on-ok="prepareAddRemark" @on-cancel="cancelAddRemark">
			<Form>
				<FormItem prop="remark" label="备注：" :label-width="48">
					<Input type="textarea" v-model="remarkForm.remark" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
				</FormItem>
			</Form>
		</Modal>
		<!-- 补录订单 -->
		<Modal v-model="suppleOrderModal.display" title="补录订单" ref="suppleOrderModal" :loading="false" :closable='false'>
			<Form inline>
				<FormItem label='下载模板' :label-width="85">
          <Button type="primary" @click="openSuppleOrderDownLoad">点击下载</Button>
				</FormItem>
				<Row>
					<FormItem label='文件' :label-width="85">
						<Upload style='display:inline-block;margin-right:10px;' :action="suppleOrderModal.uploadData.action" name="file" :format="['xlsx','xls']" ref="files" :data="suppleOrderModal.uploadData.form" :before-upload="editBeforeUpload" :on-success="editUploadSuccess" :on-error="editUploadError" :show-upload-list="false">
							<Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
						</Upload>
					</FormItem>
					<FormItem>
						<span style="display:inline-block;width: 250px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{suppleOrderModal.fileName ? suppleOrderModal.fileName : "文件名.xlsx/xls"}}</span>
					</FormItem>
				</Row>
			</Form>
			<div slot="footer">
				<Row>
					<Col span="6">
            <Button type="primary" :disabled='suppleOrderModal.importButtonLoading' @click="importRecord">导入补录记录</Button>
					</Col>
					<Col span="17">
						<Button type="primary" :loading="suppleOrderModal.importButtonLoading" @click="submitRecord">提交</Button>
						<Button type="primary" :disabled='suppleOrderModal.importButtonLoading' @click="cancelRecord">取消</Button>
					</Col>
				</Row>
			</div>
		</Modal>
		<!-- 补录订单成功弹窗 -->
		<Modal v-model="suppleRecordDisplay" title="提示" :loading="false">
      <p style="fontSize:14px;">文件提交成功，系统正在处理，请勿重复提交！</p>
      <p style="fontSize:14px;">稍等几分钟后可以查看本次导入记录</p>
			<div slot="footer">
				<Button type="text" @click="cancelSuccessModal">关闭</Button>
				<Button type="primary" @click="importRecord">导入补录记录</Button>
			</div>
    </Modal>
		<!-- 补录订单失败弹窗 -->
		<Modal v-model="suppleRecordFailDisplay" title="提示" :loading="false">
      <p style="fontSize:14px;">文件提交失败，请检查文件重新提交！</p>
      <p style="fontSize:14px;">失败原因：{{suppleRecordFailDisRemark}}</p>
			<div slot="footer">
				<Button type="primary" @click="suppleFailRecord">知道了</Button>
			</div>
    </Modal>
	</section>
</template>

<script>
import Moment from "moment";
import Utils from "../../utils";
import Config from "../../config";
import API from "../../api";
import {STORE_KEY} from "../../constants";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	async mounted() {
		this.$Notice.config({
			top: 200
		});

		this.hotspotPowerIds = ( await API.omsAPI[this.env].php.getHotSpotIds() ).data.toString();
		let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
		this.allCities = selectListResp.data.city;
		this.allHotSpots = selectListResp.data.hotspot;
		this.allHotels = selectListResp.data.chain;

		let orderSourceResp = ( await API.omsAPI[this.env].php.queryOrderSource() ).data;
		if ( orderSourceResp.retdata instanceof Array ) {
			this.sourceType = orderSourceResp.retdata;
		}
		this.queryOrderList();
	},
	data() {
		let defaultDate = [
			Moment()
				.subtract( 29, "days" )
				.format( "YYYY-MM-DD" ),
			Moment().format( "YYYY-MM-DD" )
		];
		return {
			exportBtn: {
				exportOrderInfoExcel: false,
				exportSelCheckinerInfo: false,
				exportCheckinInfoToExcel: false
			},
			// 默认值，以免渲染错误
			sourceType: [],
			allCities: [],
			allHotSpots: [],
			allHotels: [],
			column: [
				{
					title: "订单号",
					key: "orderNo",
					align: "center",
					width: 220,
					render: ( h, params ) => {
						return h(
							"a",
							{
								on: {
									click: () => {
										if ( this.$router ) {
											this.$router.push( {path: "/app/order/orderDetail", query: {orderNo: params.row.orderNo, checkinId: params.row.checkinId}} );
										} else {
											window.open( `#/Order/Reserve/newOrderDetailView?orderNo=${ params.row.orderNo }&checkinId=${ params.row.checkinId }` );
										}
									}
								}
							},
							params.row.orderNo
						);
					}
				},
				{
					title: "OTA单号",
					key: "otherNo",
					align: "center",
					width: 200
				},
				{
					title: "入住单号",
					key: "checkinId",
					align: "center",
					width: 150
				},
				{
					title: "创建时间",
					key: "createdAt",
					align: "center",
					width: 150
				},
				{
					title: "下单人",
					key: "name",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let textArr = params.row.name ? params.row.name.replace( "(", " (" ).split( " " ) : '';
						return h(
							"div",
							textArr ? textArr.map( text => {
								return h( "p", {}, text );
							}) : ''
						);
					}
				},
				{
					title: "入住人",
					key: "checkinerName",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let textArr = params.row.checkinerName ? params.row.checkinerName.replace( "(", " (" ) .split( " " ) : '';
						return h(
							"div",
							textArr ? textArr.map( text => {
								return h( "p", {}, text );
							}) : ''
						);
					}
				},
				{
					title: "姓名备注",
					key: "nameRemark",
					align: "center",
					width: 200
				},
				{
					title: "预订渠道",
					key: "orderSourceName",
					align: "center",
					width: 200
				},
				{
					title: "支付状态",
					key: "payStat",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let payStat = params.row.payStat == 1 ? "未支付" : "已支付";
						return h( "div", {}, payStat );
					}
				},
				{
					title: '实际入住时间',
					key: 'actualCheckinTime',
					width: 200,
					align: 'center'
				},
				{
					title: "入住状态",
					key: "checkin",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let checkin = "";
						switch ( params.row.checkin ) {
							case 1:
								checkin = "未入住";
								break;
							case 2:
								checkin = "已入住";
								break;
							case 3:
								checkin = "已退房";
								break;
						}
						return h( "div", {}, checkin );
					}
				},
				{
					title: "订单状态",
					key: "stat",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let stat = params.row.stat == 1 ? "有效" : "无效";
						return h( "div", {}, stat );
					}
				},
				{
					title: "预入住时间",
					key: "checkinTime",
					align: "center",
					width: 200
				},
				{
					title: "预退房时间",
					key: "checkoutTime",
					align: "center",
					width: 200
				},
				{
					title: "城市",
					key: "city",
					align: "center",
					width: 200
				},
				{
					title: "门店",
					key: "chainName",
					align: "center",
					width: 200
				},
				// {
				//   title: "热点",
				//   key: "hotspotName",
				//   align: "center",
				//   width: 200
				// },
				{
					title: "房间",
					key: "roomName",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let roomName = `${ params.row.roomId }_${ params.row.roomName }_${ params.row.roomNo }`;
						return h( "div", {}, roomName );
					}
				},
				{
					title: "房间密码",
					key: "openPwd",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						return h(
							"div",
							[
								h(
									"div",
									{},
									params.row.openPwd
								),
								h(
									"a",
									{
										on: {
											click: () => {
												if ( this.checkHasPermission( 'oms_order_checkinInfo_getOpenPwd' ) ) {
													this.showPwd( params.row.checkinInfoId, params );
												}
											},
											mouseleave: () => {
												params.row.openPwd = '******';
											}
										}
									},
									"查看密码"
								)
							],
							""
						);
					}
				},
				{
					title: "租房类型",
					key: "rentType",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let rentType = ['','短租','长租','钟点房'][params.row.rentType]
						return h( "div", {}, rentType );
					}
				},
				{
					title: "操作",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						return h( "div", [
							h(
								"Button",
								{
									props: {
										type: "primary",
										size: "small"
									},
									on: {
										click: () => {
											if ( this.checkHasPermission( 'oms_order_addRemark' ) ) {
												this.remarkForm.orderNo = params.row.orderNo;
												this.openEditRemarkModal();
											}
										}
									}
								},
								"备注"
							)
						] );
					}
				}
			],
			orderList: {
				count: 0,
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
			orderListForm: {
				orderNo: "",
				phone: "",
				roomNo: "",
				stat: "S00",
				sourceType: "S00",
				checkInDate: [],
				quitDate: [],
				payStat: "S00",
				checkin: "S00",
				city: "",
				hotspotName: "",
				chainName: "",
				rentType: "S00",
				otherNo: "",
				orderName: "",
				createDate: defaultDate
			},
			remarkForm: {
				orderNo: "",
				remark: "",
				editRemarkModalDisplay: false
			},
			passWord: '密码为空',
			suppleOrderModal:{ //补录订单
				display:false,
				importButtonLoading:false,
				fileName:'',
				uploadData:{
					action:'',
					file:'',
					form:{
						userName:''
					}
				}
			},
			suppleRecordDisplay:false,//补录订单成功弹窗
			suppleRecordFailDisplay:false,//补录订单失败弹窗
			suppleRecordFailDisRemark:'',//失败原因
		};
	},
	computed: {
		hotSpots: function () {
			if ( !this.orderListForm.city ) {
				return this.allHotSpots;
			}
			return this.allHotSpots.filter( hotSpot => {
				return hotSpot.city == this.orderListForm.city;
			} );
		},
		hotels: function () {
			if ( !this.orderListForm.city && !this.orderListForm.hotspotName ) {
				return this.allHotels;
			} else if ( this.orderListForm.city && !this.orderListForm.hotspotName ) {
				return this.allHotels.filter( hotel => {
					return hotel.city == this.orderListForm.city;
				} );
			} else if ( !this.orderListForm.city && this.orderListForm.hotspotName ) {
				return this.allHotels.filter( hotel => {
					return hotel.parentId == this.orderListForm.hotspotName;
				} );
			} else {
				return this.allHotels.filter( hotel => {
					let matchCities = hotel.city == this.orderListForm.city;
					let matchHotSpot = hotel.parentId == this.orderListForm.hotspotName;
					return matchCities && matchHotSpot;
				} );
			}
		}
	},
	methods: {
		clearValue( formItemKey ) {
			if ( formItemKey == 'city' ) {
				this.orderListForm.hotspotName = "";
			}
			this.orderListForm.chainName = "";
		},
		// 当关闭选择城市选择框没有选择城市时，清空搜索框内容
		cityOpenChange(res) {
			if (!res && !this.orderListForm.city) {
				this.$refs.resetSelect.clearSingleSelect()
			}
		},
		changeDate( dateRange, formName, datePicker ) {
			if ( !dateRange[0] ) {
				this[formName][datePicker] = [];
			} else {
				let tranferDate = [];
				for ( let i = 0; i < dateRange.length; i++ ) {
					let date = Moment( dateRange[i] ).format( "YYYY-MM-DD" );
					tranferDate.push( date );
				}
				this[formName][datePicker] = tranferDate;
			}
		},
		changePage( pageIndex ) {
			this.orderList.page = pageIndex;
			this.queryOrderList();
		},
		changePageSize( pageSize ) {
			this.orderList.page = 1;
			this.orderList.pageSize = pageSize;
			this.queryOrderList();
		},
		queryOrderListWithKeyword() {
			this.orderList.page = 1;
			this.queryOrderList();
		},
		async queryOrderList() {
			this.orderList.loading = true;
			let resp = ( await this.sendQueryOrderList( this.orderList ) ).data;
			this.orderList.data = resp.content.map( order => {
				order.openPwd = '******';
				return order;
			} );
			this.orderList.count = resp.total;
			this.orderList.loading = false;
		},
		sendQueryOrderList( orderList ) {
			if ( !this.checkCreateDate() ) {
				return;
			}
			let params = {
				page: orderList.page,
				size: orderList.pageSize,
				startDate: Moment( this.orderListForm.createDate[0] ).format(
					"YYYY-MM-DD"
				),
				endDate: Moment( this.orderListForm.createDate[1] ).format( "YYYY-MM-DD" )
			};
			if ( this.orderListForm.checkInDate[0] ) {
				params.checkInTimeBegin = Moment( this.orderListForm.checkInDate[0] ).format(
					"YYYY-MM-DD"
				);
				params.checkInTimeEnd = Moment( this.orderListForm.checkInDate[1] ).format(
					"YYYY-MM-DD"
				);
			}
			if ( this.orderListForm.quitDate[0] ) {
				params.quitTimeBegin = Moment( this.orderListForm.quitDate[0] ).format(
					"YYYY-MM-DD"
				);
				params.quitTimeEnd = Moment( this.orderListForm.quitDate[1] ).format(
					"YYYY-MM-DD"
				);
			}
			this.orderListForm.orderNo
				? ( params.orderNo = this.orderListForm.orderNo )
				: "";
			this.orderListForm.phone ? ( params.phone = this.orderListForm.phone ) : "";
			this.orderListForm.roomNo
				? ( params.roomNo = this.orderListForm.roomNo )
				: "";
			this.orderListForm.stat !== "S00"
				? ( params.stat = this.orderListForm.stat )
				: "";
			this.orderListForm.sourceType !== "S00"
				? ( params.sourceType = this.orderListForm.sourceType )
				: "";
			this.orderListForm.payStat !== "S00"
				? ( params.payStat = this.orderListForm.payStat )
				: "";
			this.orderListForm.checkin !== "S00"
				? ( params.checkin = this.orderListForm.checkin )
				: "";
			this.orderListForm.city ? ( params.city = this.orderListForm.city ) : "";
			this.orderListForm.hotspotName
				? ( params.hotspotName = this.$refs.hotspotName.query )
				: "";
			this.orderListForm.chainName
				? ( params.chainName = this.$refs.chainName.query )
				: "";
			this.orderListForm.rentType !== "S00"
				? ( params.rentType = this.orderListForm.rentType )
				: "";
			this.orderListForm.orderName
				? ( params.orderName = this.orderListForm.orderName )
				: "";
			this.orderListForm.otherNo
				? ( params.otherNo = this.orderListForm.otherNo )
				: "";
			return API.omsAPI[this.env].php.queryOrderDataByDateExt( params );
		},
		checkCreateDate() {
			if ( this.orderListForm.createDate.length == 0 ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "创建日期不能为空"
				} );
				return false;
			}
			return true;
		},
		openEditRemarkModal() {
			this.remarkForm.editRemarkModalDisplay = true;
		},
		async prepareAddRemark() {
			if ( !this.remarkForm.remark ) {
				this.$Notice.error( {
					title: "添加备注失败",
					desc: "备注不能为空"
				} );
				this.$refs.editRemarkModal.buttonLoading = false;
				return;
			} else if (
				this.remarkForm.remark &&
				this.remarkForm.remark.length > 255
			) {
				this.$Notice.error( {
					title: "添加备注失败",
					desc: "备注不能超过255字"
				} );
				this.$refs.editRemarkModal.buttonLoading = false;
				return;
			}

			let resp = ( await API.omsAPI[this.env].php.addRemark(
				this.remarkForm.orderNo,
				this.remarkForm.remark
			) ).data;
			if ( resp.retCode ) {
				// 错误警告
				this.$Notice.error( {
					title: "添加备注失败",
					desc: resp.msg
				} );
			} else {
				this.$Notice.success( {
					title: "添加备注成功"
				} );

				this.remarkForm = {
					orderNo: "",
					remark: "",
					editRemarkModalDisplay: false
				};
				this.refreshOrderList();
			}
		},
		cancelAddRemark() {
			this.remarkForm = {
				orderNo: "",
				remark: "",
				editRemarkModalDisplay: false
			};
		},
		exportOrderInfoExcel() {
			let queryParamArr = this.createParamsForExport();
			queryParamArr.push(/*`hotspotPowerIds=${this.hotspotPowerIds}`,*/`page=1&size=999999` )
			// let url = `Interface/index.php/Home/Reserve/exportOrderInfoExcel?${queryParamArr.join("&")}`;
			let url = `${ Config[this.env].analysisUrl }excel/selOrderInfo?${ queryParamArr.join( "&" ) }`

			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "exportOrderInfoExcel" )
		},
		exportCheckinInfoToExcel() {
			// let url = `Interface/index.php/Home/Reserve/exportCheckInInfoExcel?startDate=${Moment(
			let url = `${ Config[this.env].analysisUrl }excel/selCheckInInfo?startDate=${ Moment(
				this.orderListForm.createDate[0]
			).format( "YYYY-MM-DD" ) }&endDate=${ Moment(
				this.orderListForm.createDate[1]
			).format( "YYYY-MM-DD" ) }&page=1&size=999999&hotspotPowerIds=` + this.hotspotPowerIds;
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "exportCheckinInfoToExcel")
		},
		exportSelCheckinerInfo() {
			if ( !this.checkHasPermission( 'excel_selCheckinerInfo' ) ) {
				return;
			}
			if ( this.orderListForm.checkInDate.join( '' ).length == 0 || ( !this.orderListForm.city && !this.orderListForm.chainName ) ) {
				this.$Notice.error( {
					title: "导出失败",
					desc: "请选择入住日期，并至少选择一个城市 或 门店"
				} );
				return;
			}

			let queryParamArr = this.createParamsForExport();
			queryParamArr.push(/*`hotspotPowerIds=${this.hotspotPowerIds}`,*/`page=1&size=999999` )
			let url = `${ Config[this.env].analysisUrl }excel/selCheckinerInfo?${ queryParamArr.join( "&" ) }`

			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "exportSelCheckinerInfo")
		},
		createParamsForExport() {
			let queryParamArr = [];
			for ( let key in this.orderListForm ) {
				if ( key == "createDate" ) {
					let str = `startDate=${ this.orderListForm.createDate[0] ? Moment(
						this.orderListForm.createDate[0]
					).format( "YYYY-MM-DD" ) : '' }&endDate=${ this.orderListForm.createDate[1] ? Moment(
						this.orderListForm.createDate[1]
					).format( "YYYY-MM-DD" ) : '' }`;
					queryParamArr.push( str );
					continue;
				} else if ( key == "checkInDate" ) {
					if ( this.orderListForm.checkInDate.length > 0 ) {
						let str = `checkInTimeBegin=${ this.orderListForm.checkInDate[0] ? Moment(
							this.orderListForm.checkInDate[0]
						).format( "YYYY-MM-DD" ) : '' }&checkInTimeEnd=${ this.orderListForm.checkInDate[1] ? Moment(
							this.orderListForm.checkInDate[1]
						).format( "YYYY-MM-DD" ) : '' }`;
						queryParamArr.push( str );
					}
					continue;
				} else if ( key == "quitDate" ) {
					if ( this.orderListForm.quitDate.length > 0 ) {
						let str = `quitTimeBegin=${ this.orderListForm.quitDate[0] ? Moment(
							this.orderListForm.quitDate[0]
						).format( "YYYY-MM-DD" ) : '' }&quitTimeEnd=${ this.orderListForm.quitDate[1] ? Moment(
							this.orderListForm.quitDate[1]
						).format( "YYYY-MM-DD" ) : '' }`;
						queryParamArr.push( str );
					}
					continue;
				} else if ( key == "hotspotName" || key == "chainName" ) {
					let str = `${ key }=${ this.orderListForm[key] ? this.$refs[key].query : "" }`
					queryParamArr.push( str );
					continue;
				}
				let str = "";
				if ( this.orderListForm[key] == "S00" ) {
					str = `${ key }=`;
				} else {
					str = `${ key }=${ this.orderListForm[key] || '' }`;
				}
				queryParamArr.push( str );
			}
			return queryParamArr;
		},
		refreshOrderList() {
			this.orderList = {
				count: 0,
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
			this.queryOrderList();
		},
		insteadOfOrder() {
			if ( !this.checkHasPermission( 'oms_order_bookOrder' ) ) {
				return
			}
			if ( this.$router ) {
				// 新OMS跳转
				window.open( "#/app/Order/createOrder", "_blank" );
			} else {
				// 旧OMS跳转
				window.open( "#/Order/Reserve/createNewOrderPage", "_blank" );
			}
			// 调用angular modal
			// document.querySelector('[href="#order-modal"]') &&
			//   document.querySelector('[href="#order-modal"]').click();
		},
		frontOrder() {
			if ( !this.checkHasPermission( 'oms_order_frontDestOrder' ) ) {
				return;
			}

			if ( this.$router ) {
				// 新OMS跳转
				window.open( "#/app/Order/frontOrder", "_blank" );
			} else {
				// 旧OMS跳转
				window.open( "#/Order/Reserve/frontDestOrder", "_blank" );
			}
		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
		async showPwd( checkinInfoId, params ) {
			let resp = ( await API.omsAPI[this.env].order.getOpenPwd(
				{checkinInfoId: checkinInfoId},
				this.token
			) ).data
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取密码失败"
				} )
			}
			if ( typeof resp == "object" ) {
				resp = '密码为空'
			}
			params.row.openPwd = resp;
		},
		/** --------------------------------补录订单----------------------------- */ 
		suppleOrder(){
			if ( !this.checkHasPermission( 'importOrderRecord' ) ) {
				return;
			}
			this.suppleOrderModal.importButtonLoading = false
			this.suppleOrderModal.fileName = ''
			this.suppleOrderModal.uploadData.action = `${ Config[this.env].analysisUrl }importOrderRecord`
			this.suppleOrderModal.uploadData.file = ''
			this.suppleOrderModal.uploadData.form.userName = this.username
			this.suppleOrderModal.display = true
		},
		// 下载模板
		openSuppleOrderDownLoad(){
			let url = 'https://public-test.xbed.com.cn/%E8%A1%A5%E5%BD%95%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx';
			window.open( url, "_blank" );
		},
		editBeforeUpload(file){
			let regResult = /\.(?:xlsx|xls)$/.test( file.name );
			if(!regResult){
				this.$Notice.error( {
					title: "导入失败",
					desc: "请导入xlsx格式的excel文件"
				});
			} else {
				this.suppleOrderModal.uploadData.file = file
				this.suppleOrderModal.fileName = file.name
			}
      return false;
		},
		editUploadError(e,error){
			this.suppleOrderModal.importButtonLoading = false
			let msg = error.msg ? error.msg : "请稍后再试"
      this.$Notice.error( {
				title: "导入失败",
				desc: msg
			});
		},
		submitRecord(){
			if ( !this.checkHasPermission( 'importOrderRecordSubmit' ) ) {
				return;
			}
      if(!this.suppleOrderModal.uploadData.file){
        this.$Notice.error( {
					title: "导入失败",
					desc: "请导入xlsx/xls格式的excel文件"
				});
				this.suppleOrderModal.importButtonLoading = false
				return;
			}
			this.suppleOrderModal.importButtonLoading = true
			this.suppleOrderModal.uploadData.form.userName = this.username;
			this.$refs.files.post(this.suppleOrderModal.uploadData.file);
		},
		editUploadSuccess(resp){
			this.suppleOrderModal.importButtonLoading = false
			if(resp.retCode != 21020000){
				this.suppleRecordFailDisRemark = resp.msg
				this.suppleOrderModal.display = false
				this.suppleRecordFailDisplay = true
				return
			}
			this.$Notice.success({
				title: "导入成功",
				desc: resp.msg
			});
			this.suppleOrderModal.display = false
			this.suppleRecordDisplay = true
		},
		cancelRecord(){
			this.suppleOrderModal.display = false
		},
		importRecord(){
			if ( !this.checkHasPermission( 'rder_supplementaryOrder' ) ) {
				return;
			}
			this.suppleRecordDisplay = false
			setTimeout(()=>{
				if (this.$router) {
					this.$router.push({path:'/app/order/supplementary-order'})
				} else{
          window.open( `#/Order/Reserve/supplementaryOrder` );
				}
			},500)
		},
		cancelSuccessModal(){
			this.suppleRecordDisplay = false
		},
		suppleFailRecord(){
      this.suppleRecordFailDisplay = false
		}
	}
};
</script>

<style lang="scss" scoped>
.order-list {
	margin-top: 10px;
	margin-bottom: 16px;
}
</style>





// WEBPACK FOOTER //
// src/pages/order/order-list.vue